import { render, staticRenderFns } from "./internbudgetfrm.vue?vue&type=template&id=4fe2706e"
import script from "./internbudgetfrm.vue?vue&type=script&lang=js"
export * from "./internbudgetfrm.vue?vue&type=script&lang=js"
import style0 from "./internbudgetfrm.vue?vue&type=style&index=0&id=4fe2706e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports